export default __webpack_public_path__ + "static/media/WirelessMotor.80d908ab.jpg";